export const OPEN_API_BASE: string =
  process.env.REACT_APP_OPEN_API_BASE ||
  (window as any).ENV.REACT_APP_OPEN_API_BASE ||
  'https://compliance-manager.eu.aldryn.io/grc/v1';
// admin is on a different cloud project, so no relative urls
export const DJANGO_ADMIN_URL =
  'https://compliance-manager.eu.aldryn.io/admin/';
